<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title>{{ formTitle }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="local.categoria_gasto_id"
              :items="categoriasGasto"
              item-title="descripcion"
              item-value="id"
              label="Categoría"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="local.auto_id"
              :items="autos"
              :item-title="autoLabel"
              item-value="id"
              label="Auto (opcional)"
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="local.fecha"
              type="date"
              label="Fecha"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="local.monto"
              type="number"
              step="0.01"
              min="0"
              label="Monto (S/)"
              :rules="[v => v >= 0 || 'Inválido']"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="local.descripcion"
              label="Descripción"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="local.comprobante"
              label="Comprobante (opcional)"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelar">Cancelar</v-btn>
        <v-btn color="primary" variant="flat" @click="guardar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    editedItem: { type: Object, default: () => ({}) },
    formTitle: String,
    categoriasGasto: { type: Array, default: () => [] },
    autos: { type: Array, default: () => [] },
  },
  emits: ['update:dialog', 'save'],
  data() {
    return {
      local: this.buildLocal(this.editedItem),
    };
  },
  watch: {
    editedItem: {
      handler(n) {
        this.local = this.buildLocal(n);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    buildLocal(item) {
      const today = new Date().toISOString().slice(0, 10);
      return {
        id: null,
        categoria_gasto_id: null,
        auto_id: null,
        fecha: today,
        descripcion: '',
        monto: 0,
        comprobante: '',
        ...(item || {}),
      };
    },
    autoLabel(a) {
      return `${a.placa} - ${a.marca} ${a.modelo}`;
    },
    cancelar() {
      this.$emit('update:dialog', false);
    },
    guardar() {
      this.$emit('save', { ...this.local });
    },
  },
};
</script>
